import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { cn } from "@/lib/utils";

interface Props {
  stagger?: number;
  delay?: number;
  show?: boolean;
  class?: string;
}

// Set up clean defaults for any instance of your list

export default /*@__PURE__*/_defineComponent({
  __name: 'AnimatedList',
  props: {
    stagger: { default: 0.05 },
    delay: { default: 0 },
    show: { type: Boolean, default: true },
    class: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_unref(cn)('content', props.class)),
        style: _normalizeStyle({
      '--list-delay': `${__props.delay}s`,
      '--list-stagger': `${__props.stagger}s`,
    })
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 6))
    : _createCommentVNode("", true)
}
}

})